import React from 'react';
import { ConsentAttribute } from 'src/constrains/AdvancedFilters/Components';

import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail/Filters/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import { IntClear } from '../Components';

//name,options
const _ConsentAttribute = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    root,
    form,

    radioName,
    selectName,
    options,
    state,
    disabled,
  } = props;
  return (
    <SectionWrapper
      title={getI18n('customerTag.consentAttribute.consentattribute')}>
      <ItemWrapper title=''>
        <ConsentAttribute
          disabled={disabled}
          selectName={selectName}
          selectOptions={options || []}
          radioName={radioName}
          hasExclude={false}
        />
        <IntClear
          form={form}
          root={root}
          value={radioName}
          state={state}
          disabled={disabled}
        />
      </ItemWrapper>
    </SectionWrapper>
  );
};
export default _ConsentAttribute;
